import { Box, styled } from "@material-ui/core";
import { Link } from "react-router-dom";
import {
  EPOCUS_BORDER,
  EPOCUS_PRIMARY_HOVER_BG,
  EPOCUS_WHITE,
} from "../../_lib/epocus-palette";

const ROW = {
  padding: 16,
  display: "flex",
  flexDirection: "column" as const,
  gap: 2,
  textDecoration: "none",
  color: "inherit",
  borderBottom: `1px solid ${EPOCUS_BORDER}`,
  "&:last-child": {
    borderBottom: "none",
  },
};

export const AdminList = styled(Box)({
  backgroundColor: EPOCUS_WHITE,
  borderRadius: 12,
  border: `1px solid ${EPOCUS_BORDER}`,
  overflow: "hidden",
});

export const AdminListScroll = styled(Box)({
  maxHeight: 420,
  overflowY: "auto",
});

export const AdminListRow = styled(Box)(ROW);

export const AdminListLinkRow = styled(Link)({
  ...ROW,
  cursor: "pointer",
  "&:hover": {
    backgroundColor: EPOCUS_PRIMARY_HOVER_BG,
  },
});
